// import { stringify } from 'flatted';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './registerServiceWorker';
// import { postError } from './lib/API';

function patchRouterMethod( _router, methodName ) {
	router[`old ${methodName}`] = router[methodName];
	router[methodName] = async function ( location ) {
		return router[`old ${methodName}`]( location ).catch( ( error ) => {
			if ( error.name === 'NavigationDuplicated' ) {
				return this.currentRoute;
			}
			throw error;
		} );
	};
}

// function printRest( ...data ) {
// 	// console.log( data );
// 	// console.log( stringify( { data } ) );
// }

// Vue.config.errorHandler = ( err, vm, info ) => {
// 	// console.log( 'Vue Error~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// console.log( err );
// 	// console.log( vm );
// 	// console.log( info );
// 	// console.log( 'Vue Error End~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// printRest( err, vm, info );
// 	postError( err, vm, info );
// };

// window.onerror = ( msg, url, line, col, error ) => {
// 	// console.log( 'Non-Vue Error~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// console.log( msg );
// 	// console.log( url );
// 	// console.log( line );
// 	// console.log( col );
// 	// console.log( error );
// 	// console.log( 'Non-Vue Error End~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// printRest( msg, url, line, col, error );
// 	postError( msg, url, line, col, error );
// };

// window.addEventListener( 'unhandledrejection', ( event ) => {
// 	// console.log( 'Unhandled Rejection Error~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// console.log( event );
// 	// console.log( 'unhandled Rejection Error End~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
// 	// printRest( event );
// 	postError( event );
// } );

patchRouterMethod( router, 'push' );
patchRouterMethod( router, 'replace' );

Vue.config.productionTip = false;
Vue.config.devtools = true;

window.Vue = Vue;

// window.addEventListener( 'beforeunload', ( e ) => {
// 	console.log( 'this is the before unload function.' );
// 	e.preventDefault();
// 	e.returnValue = 'This is the return Value.';
// } );

new Vue( {
	router,
	store,
	render : h => h( App ),
} ).$mount( '#app' );
